import {
  TranslateResult,
} from 'vue-i18n';

import {
  i18n,
} from '@/plugins/vue-i18n';

type Title = string | TranslateResult;

interface OpenGraphMetaPayload {
  title?: string;
  description?: string;
  image?: string;
}

interface HeadMeta {
  property: string;
  content: string;
  vmid?: string;
}

class MetaInfoHelper {
  private readonly appTitle: string = `${i18n.t('metaInfo.applicationToCreateCommercial')}`;

  private readonly defaultDelimiter: string = '|';

  public get titleTemplate(): string {
    return `%s – ${this.appTitle.toLowerCase()}`;
  }

  public get defaultTitle(): string {
    return 'Offer Manager';
  }

  public get defaultDescription(): string {
    return `${i18n.t('metaInfo.applicationToFastCreateCommercialForClients')}`;
  }

  // Title template will append automatically (check App.vue -> @Component.metaInfo)
  public getHeadTitle(title?: Title, subtitle?: Title): string {
    let resultTitle = this.defaultTitle;

    if (title) {
      resultTitle = `${title}`;
    }

    if (title && subtitle) {
      resultTitle = `${title} ${this.defaultDelimiter} ${subtitle}`;
    }

    return resultTitle;
  }

  public getHeaderOGMeta(data: OpenGraphMetaPayload): HeadMeta[] {
    const OGMeta = [
      this.getOGTitle(data.title),
      this.getOGDescription(data.description),
      this.generateMetaData('og:url', __config.url.default),
      this.generateMetaData('og:site_name', this.defaultTitle),
      this.generateMetaData('og:type', 'website'),
      this.generateMetaData('og:locale', 'ru_RU'),
      this.generateMetaData('og:image', `${__config.url.default}/img/logo/om-og-logo-1200x630.png`, 'og:image:logo_l'),
      this.generateMetaData('og:image:width', '1200', 'og:image:width:logo_l'),
      this.generateMetaData('og:image:height', '630', 'og:image:height:logo_l'),
      this.generateMetaData('og:image', `${__config.url.default}/img/logo/om-og-logo-600x315.png`, 'og:image:logo_m'),
      this.generateMetaData('og:image:width', '600', 'og:image:width:logo_m'),
      this.generateMetaData('og:image:height', '315', 'og:image:height:logo_m'),
      this.generateMetaData('og:image', `${__config.url.default}/img/logo/om-og-logo-250x250.png`, 'og:image:logo_s'),
      this.generateMetaData('og:image:width', '250', 'og:image:width:logo_s'),
      this.generateMetaData('og:image:height', '250', 'og:image:height:logo_s'),
    ];

    if (data.image) {
      OGMeta.push(this.generateMetaData('og:image', data.image));
    }

    return OGMeta;
  }

  public getOGTitle(content?: Title, vmid?: string): HeadMeta {
    return {
      property: 'og:title',
      content: this.generateTemplateTitle(content ? `${content}` : this.defaultTitle),
      vmid: vmid || 'og:title',
    };
  }

  public getOGDescription(content?: Title, vmid?: string): HeadMeta {
    return {
      property: 'og:description',
      content: content ? `${content}` : this.defaultDescription,
      vmid: vmid || 'og:description',
    };
  }

  public generateMetaData(property: string, content: string, vmid?: string): HeadMeta {
    return {
      property,
      content,
      vmid: vmid || property,
    };
  }

  private generateTemplateTitle(title: string): string {
    return this.titleTemplate.replace('%s', title);
  }
}

const metaInfoHelper = new MetaInfoHelper();

export {
  MetaInfoHelper,
  metaInfoHelper,
  OpenGraphMetaPayload,
  HeadMeta,
};
